export default "__VITE_ASSET__CR08n2d6__"